import { makeStyles, Theme } from '@surveycake/rc';

const getTdStyle = (theme: Theme) => `
	color: ${theme.color.text.B4};
	padding: 4px;
	line-height: 1.42857143;
	text-align: center;
`;

export const useStyles = makeStyles([
  [
    'calendar',
	`
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		width: 100%;
		border-spacing: 0;
		border-collapse: collapse;
		user-select: none;
	`
  ],
  [
    'week',
    theme => `
		${getTdStyle(theme)}
		color: ${theme.color.text.B5};
		font-size: 12px;
		font-weight: 700;
		text-transform: uppercase;
	`
  ],
  [
    'notThisMonth',
    theme => `
		color: ${theme.color.text.B2};
	`
  ],
  [
    'active',
    theme => `
		color: ${theme.color.text.white};
		background-color: ${theme.color.primary.default};
	`
  ],
  [
    'disabled',
    `
		cursor: not-allowed;
	`
  ],
  [
    'day',
    (theme, deps, classes) => `
		${getTdStyle(theme)}
		width: ${100 / 7}%;
		cursor: pointer;

		&:not(.${classes.disabled}):hover {
			color: ${theme.color.text.white};
			background-color: ${theme.color.primary.default};
		}
	`
  ]
]);
